import React from 'react'
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { useState, useRef } from "react";
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import axios from 'axios';
import { Toast } from "primereact/toast";
import { TbChristmasBall } from "react-icons/tb";
const WishAdd = ({ onClose, eventID }) => {
    const { accessToken, userId, role, username } = useAuth();
    const toast = useRef(null);
    const [value, setValue] = useState("");
    const [file, setFile] = useState(null);
    const [isValidURL, setIsValidURL] = useState(true);

    const validateURL = (url) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    const handleURLChange = (e) => {
        const input = e.target.value;
        setValue(input);
        setIsValidURL(validateURL(input));
    };

    const onSelectFile = (e) => {
        const selectedFile = e.files[0];
        const imgURL = URL.createObjectURL(selectedFile);
        setFile({ raw: selectedFile, preview: imgURL });
    };

    const removeImage = () => {
        setFile(null);
    };

    const handleGiftUploadSave = async () => {
        if (!file) {
            toast.current.show({
                severity: "warn",
                summary: "Image Missing",
                detail: "Please upload a gift image!"
            });
            return;
        }

        if (!value) {
            toast.current.show({
                severity: "warn",
                summary: "URL Missing",
                detail: "Please enter the Gift link!"
            });
            return;
        }

        if (!isValidURL) {
            toast.current.show({ severity: "error", summary: "Invalid URL", detail: "Please enter a valid URL!" });
            return;
        }
        try {
            const formData = new FormData();

            // Attach image
            formData.append("image", file.raw);

            // Attach required values
            formData.append("amazon_url", value);
            formData.append("event_id", eventID);  // <-- you said this comes from previous page
            formData.append("user_id", userId);

            // if (userId) {
            //     formData.append("participant_id", userId); // for update mode
            // }

            await axios.post(
                `${config.apiBASEURL}/SecretSantaRoutes/participant`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            onClose();

        } catch (err) {
            console.error("Participant save failed:", err);
        }
    };

    return (
        <div>
            <Toast ref={toast} />
            <h5 className="mb-4 pb-3 border-bottom text-danger  d-flex align-items-center justify-content-center gap-3"><TbChristmasBall /> <span className='text-secondary'>Make Your Wish <b className='text-danger'>{username}!</b></span> <TbChristmasBall /></h5>

            <div className="mb-3">
                <label className="mb-2">Gift Image *</label>
                {!file ? (
                    <FileUpload
                        mode="basic"
                        accept="image/*"
                        maxFileSize={1000000}
                        auto
                        customUpload
                        chooseLabel="Choose Image"
                        onSelect={onSelectFile}
                    />
                ) : (
                    <div className="preview-container position-relative">
                        <img src={file.preview} className="preview-img rounded w-100" alt="preview" />
                        <Button
                            icon="pi pi-trash"
                            severity="danger"
                            rounded
                            className="delete-btn position-absolute"
                            onClick={removeImage}
                        />
                    </div>
                )}
            </div>

            <div className="mb-3">
                <label className="mb-2">Gift URL Link *</label>

                <InputText
                    value={value}
                    onChange={handleURLChange}
                    className={`w-100 ${!isValidURL ? "p-invalid" : ""}`}
                    placeholder="Enter product link"
                />

                {!isValidURL && value && (
                    <small className="p-error">Please enter a valid URL.</small>
                )}
            </div>


            <Button
                label="Save Wish"
                severity="danger"
                icon="pi pi-gift"
                className="py-2 mt-4 d-block w-100"
                onClick={handleGiftUploadSave}
            />
            <div className="border p-3 mt-4">
                <p className="mb-2 text-danger"><em><b>Rules</b></em></p>
                <p className="mb-0"><small className="text-muted">
                    <b className="d-block mb-2">Hello Everyone,</b>

                    It’s time for *Secret Santa*! 🎅🎁
                    Please follow the steps below so we can keep the process smooth and fun:

                    <span className="d-block mb-1">
                        <small className="d-block mb-1 text-danger">Randomiser & Name Assignment</small>
                        A randomiser will be used to assign each of you a Secret Santa name.
                    </span>

                    <span className="d-block mb-1">
                        <small className="d-block mb-1 text-danger">Submit Your Gift Preference</small>
                        Please log in to the *ERP portal* and fill in the Secret Santa section.
                        You will be required to submit:
                    </span>
                    <span className="d-block mb-1">
                        <small className="d-block mb-1">One product page link* from Amazon/Any other Ecom Platform</small>
                        <small className="d-block mb-1"><b>One product image</b> (from the same Platform link)</small>
                        <small className="d-block">
                            <b>Price Range:</b> ₹500 - ₹600 <br />
                            (Please make sure your selected item does **not exceed* the limit.)
                            <b className='p-0 mb-0 text-danger'>(Also Make sure the gift has a delivery date of max  19th December)</b>
                        </small>
                    </span>

                    <span className="d-block mb-1">Let’s keep it fun, thoughtful, and within budget!<br />
                        If you have any questions, feel free to reach out.</span>

                    <b>Happy gifting! 🎄✨</b>

                </small></p>

            </div>

        </div>
    )
}

export default WishAdd